import { useLocation } from "react-router-dom";
import { getSearchPage } from "../../utils/searchMetadata";
import { MarketingBody, MarketingHero, SearchContact } from "../../components/search/PublicContent";

export default function SearchLandingPage() {
  const { pathname } = useLocation();
  const page = getSearchPage(pathname);
  return <><MarketingHero page={page} /><MarketingBody page={page} /><SearchContact /></>;
}
